import { getCurrentReader } from '../auth/getCurrentReader';
const BASE = process.env.REACT_APP_FOLLOW_API_BASE || 'https://j8s1yjjjuf.execute-api.us-west-2.amazonaws.com/default';
export async function readerRequest(url, { signal, owner, ids, method = ids ? 'POST' : 'GET', body } = {}) {
  const controller = new AbortController();
  const abort = () => controller.abort();
  if (signal?.aborted) controller.abort();
  signal?.addEventListener('abort', abort);
  let timer;
  const work = async () => {
    const reader = await getCurrentReader();
    if (!reader?.idToken || !reader.readerSub || (owner && reader.readerSub !== owner)) throw new Error('Please sign in to your Reader account again.');
    if (controller.signal.aborted) throw new Error('Request cancelled.');
    const payload = ids ? {notificationIds:ids} : body;
    const response = await fetch(url, { method, headers: { Authorization: `Bearer ${reader.idToken}`, ...(payload ? {'Content-Type':'application/json'} : {}) }, ...(payload ? {body:JSON.stringify(payload)} : {}), signal:controller.signal });
    if (!response.ok) throw new Error('We couldn’t load or save your reader activity. Please retry.');
    const data = await response.json();
    const current = await getCurrentReader();
    if (current?.readerSub !== reader.readerSub || controller.signal.aborted) throw new Error('Your account changed or the request ended. Please retry.');
    return {...data, readerSub:reader.readerSub};
  };
  try { return await Promise.race([work(), new Promise((_, reject) => {timer=setTimeout(()=>{controller.abort();reject(new Error('The request took too long. Please retry.'));},20000);})]); }
  finally {clearTimeout(timer);signal?.removeEventListener('abort',abort);}
}
export async function requestReadState(ids, options = {}) {
  const data = await readerRequest(`${BASE}/${ids ? 'mark-reader-notifications-read' : 'get-reader-notification-reads'}`, {...options,ids});
  if(!Array.isArray(data.notificationIds)||data.notificationIds.some(id=>typeof id!=='string'))throw new Error('Read status is unavailable. Please retry.');
  return data;
}
export async function requestNotifications(options = {}) {
  const data=await readerRequest('https://u36mf26174.execute-api.us-west-2.amazonaws.com/default/getreadernotifications',options);
  if(!Array.isArray(data.notifications)||data.notifications.some(item=>!item||typeof item!=='object'||Array.isArray(item)))throw new Error('Your updates are unavailable. Please retry.');
  return data;
}
export async function requestReaderGreeting(options = {}) {
  const data=await readerRequest('https://b94ixba2nk.execute-api.us-west-2.amazonaws.com/default/fetch-reader-profile',options);
  if(typeof data.firstName!=='string'||typeof data.displayName!=='string')throw new Error('Reader profile unavailable.');
  return data;
}
